export default __webpack_public_path__ + "static/media/minDepIcon.4b2d99ee.svg";